import Axios from "axios";

const baseURL = process.env.BARRAMUNDI;

export default {
    async getPreferences() {
        let res = await Axios.get(`${baseURL}actor/user-preferences`);
        return res?.data?.response?.resource?.json ?? []; // if no result (nothing), return empty array (mandatory!)
    },
    async updatePreferences(category, data) {
        let res = await Axios.post(
            process.env.BARRAMUNDI + "actor/user-preferences",
            {
                category: category,
                json: JSON.stringify(data) // backend only accept string as it will be saved in dynamodb
            }
        );

        return res?.data || null;
    }
};
